import { useMemo, type LegacyRef, type MutableRefObject } from 'react';
import { mergeRefs } from '../react/mergeRefs';

export function useMergedRefs<T = unknown>(refs: (MutableRefObject<T> | LegacyRef<T>)[]): React.RefCallback<T> {
  return useMemo(() => mergeRefs(refs), [refs]);
}
